import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-popup-select-hospital',
  templateUrl: './popup-select-hospital.component.html',
  styleUrls: ['./popup-select-hospital.component.scss'],
  standalone: false,
})
export class PopupSelectHospitalComponent implements OnInit {
  private isMultiHospitals: boolean = false;

  public hospitals: any[] = [];

  public selectedHospital: any;

  public hospitalsSelected: boolean = true;

  public compatible: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<PopupSelectHospitalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService
  ) {
    dialogRef.disableClose = true;
    this.hospitalsSelected = data.hospitalsSelected;
    this.compatible = data.compatible;
  }

  ngOnInit() {
    this.isMultiHospitals = this.userService.isCurrentUserHasMultipleHospitals();
    if (this.isMultiHospitals) {
      this.getUserHospitals();
    }
  }

  getUserHospitals() {
    const userHospitals = [...(this.userService.usersHospitals ?? [])];
    userHospitals.forEach((hospital: any) => {
      this.hospitals.push({
        name: hospital.name,
        id: hospital._id,
        displayName: hospital.displayName,
      });
    });
  }

  onChangeHospital(event: any) {
    this.userService.saveSelectedHospitals([event.id]);
    this.dialogRef.close({ success: true });
  }

  close(): void {
    this.dialogRef.close({ isClosePopup: true });
  }
}
